import {
    fabric
} from "fabric-with-erasing";
import { saveAs } from "file-saver";
import { getRelatedObject, setObjectPerspective } from './fabricPerspective';

import i18n from 'i18next';

export const dfItemColor = "rgba(0, 0, 0, 1)";


export const customProps = [
    "id",
    "windowItemId",
    "doorStackImageId",
    "windowStackImageId",
    "windowType",
    "windowImageURL",
    "backgroundItemId",
    "optionItemId",
    "optionType",
    "evented",
    "alpha",
    "itemColor",
    "sidelightPosition",
    "itemUrl",
    "cutoutSize",
    "erasable",
    "windowGridType",
    "scaleFactor",
    "bgImageProps",
    "usePerspective",
    "originObject",
    "tmpScaleX",
    "tmpScaleY",
    "relatedGroupId",
    "groupId",
    "itemType",
    "isDimension",
    "originalOpacity",
];

let panX = 0;
let panY = 0;
var cloneItem = null;

let times = 0;

export async function waitForAnimationFrames(frames = 2) {
    for (let i = 0; i < frames; i += 1) {
        await new Promise((resolve) => requestAnimationFrame(() => resolve()));
    }
}

// Enhanced Canvas State Save Function with Comparison
export function saveCanvasState(canvas, zPerc = null, hasCanvasChanged = true) {
    if (!hasCanvasChanged) return false;
  
    if (canvas.stateaction && canvas.state) {
      let newstate = [];
      let index = canvas.index;
      let state = canvas.state;
  
      // Create the new state based on zoom or canvas content
      let newStateObject;
      if (zPerc) {
        newStateObject = { type: "zoom", zPerc: zPerc };
      } else {
        newStateObject = canvas.toJSON(customProps);
      }
  
      // Check if the new state is different from the last state
      const newStateString = JSON.stringify(newStateObject);
      const lastStateString = state.length > 0 ? JSON.stringify(state[index]) : "";
  
      if (newStateString === lastStateString) {

        // console.log("Skipping save as state is identical to the last one.");

        return false;
      }
  
      // Create a new state array up to the current index
      for (let i = 0; i <= index; i++) {
        newstate.push(state[i]);
      }
  
      // Add the new state and update index
      newstate[++index] = newStateObject;
  
      // Trim any future states beyond this index to maintain consistency
      newstate = newstate.slice(0, index + 1);
  
      // Limit the history to avoid memory overflow
      if (newstate.length >= 80) newstate = newstate.splice(-5, 5);
      canvas.state = newstate;
      canvas.index = index;
  

    //   console.log("Saved new state at index:", index, "State length:", newstate.length);

    }
  
    return false;
  }
  
  

  export function undo(canvas, hasCanvasChanged) {

    // console.log("Inside undo function");
    // console.log("Canvas:", canvas);
    // console.log("HasCanvasChanged:", hasCanvasChanged);
    
    if (hasCanvasChanged && canvas) {
      canvas.stateaction = false; // Temporarily disable state tracking
      var index = canvas.index;
      var state = canvas.state;
  
      if (index > 0) {
        // Decrement the index to go back in history
        index -= 1;
        var json = state[index];
  
        if (json && json.zPerc) {
          // Handle zoom-specific state
          canvas.setZoom(json.zPerc);
          canvas.renderAll();
          canvas.index = index;
          canvas.stateaction = true;
        } else {
          // Handle canvas JSON state
          canvas.loadFromJSON(json, function () {
            canvas.renderAll();
            canvas.index = index;
            canvas.stateaction = true;
  
            // Additional handling for polygons with perspective
            let objects = canvas.getObjects();
            for (let i = 0; i < objects.length; i++) {
              if (objects[i].type === "polygon" && objects[i].usePerspective) {
                objects[i].originObject = getRelatedObject(canvas, objects[i]);
                objects[i].objectCaching = false; // Ensure caching is disabled
                canvas.renderAll();
              }
            }
          });
        }
      } else {
        // Handle the case when undo is at the beginning of the history
        canvas.stateaction = true; // Re-enable state tracking
      }
    }
  }
  
  
  export function redo(canvas, hasCanvasChanged) {
    if (hasCanvasChanged && canvas) {
      var index = canvas.index;
      var state = canvas.state;
      canvas.stateaction = false; // Temporarily disable state tracking
  
      if (index < state.length - 1) {
        // Increment the index to go forward in history
        index += 1;
        var json = state[index];
  
        if (json && json.zPerc) {
          // Handle zoom-specific state
          canvas.setZoom(json.zPerc);
          canvas.renderAll();
          canvas.index = index;
          canvas.stateaction = true;
        } else {
          // Handle canvas JSON state
          canvas.loadFromJSON(json, function () {
            canvas.renderAll();
            canvas.index = index;
            canvas.stateaction = true;
  
            // Additional handling for polygons with perspective
            let objects = canvas.getObjects();
            for (let i = 0; i < objects.length; i++) {
              if (objects[i].type === "polygon" && objects[i].usePerspective) {
                objects[i].originObject = getRelatedObject(canvas, objects[i]);
                objects[i].objectCaching = false; // Ensure caching is disabled
                canvas.renderAll();
              }
            }
          });
        }
      } else {
        // Handle the case when redo is at the end of the history
        canvas.stateaction = true; // Re-enable state tracking
      }
    }
  }
  
  

export function fadeObjects(canvas, callback) {
    let numObjects = canvas.getObjects().length;
    let numCompleted = 0;

    canvas.discardActiveObject();
    canvas.renderAll();

    // Check if all animations are complete
    const checkComplete = () => {
        numCompleted++;
        if (numCompleted === numObjects) {
            if (callback) {
                callback();
            }
        }
    };

    // Fade out all objects to opacity 0
    canvas.getObjects().forEach(obj => {
        let originalOpacity = obj.opacity;
        obj.animate('opacity', 0, {
            duration: 300,
            onChange: canvas.renderAll.bind(canvas),
            onComplete: function () {
                // Pause for 3 seconds after fade out
                setTimeout(() => {
                    // Fade objects back in to their original opacity over 1.5 seconds
                    obj.animate('opacity', originalOpacity, {
                        duration: 1500, // Changed from 500 to 1500 milliseconds = 1.5 seconds
                        onChange: canvas.renderAll.bind(canvas),
                        onComplete: checkComplete
                    });
                }, 2500); // 3 seconds pause
            }
        });
    });
}




export function removeAllObjects(canvas) {
    const message = i18n.t('confirmDelete');  
    if (window.confirm(message)) {
        var activeObject = canvas.getActiveObject();
        if (!activeObject) return;
        if (activeObject.type === "activeSelection") {
            activeObject.forEachObject((object) => {
                canvas.remove(object);
            });
        } else {
            canvas.remove(activeObject);
        }
    }
}

export function removeAllObjects2(canvas) {
    const message = i18n.t('confirmDelete');  
    if (window.confirm(message)) {
        canvas.getObjects().forEach(obj => {
            canvas.remove(obj);
        });
        canvas.discardActiveObject(); // Clear selection
        canvas.requestRenderAll(); // Re-render the canvas
    }
}


export function removeUndoAllObjects(canvas) {

    var activeObject = canvas.getActiveObject();
    if (!activeObject) return;
    if (activeObject.type === "activeSelection") {
        activeObject.forEachObject((object) => {
            canvas.remove(object);
        });
    } else {
        canvas.remove(activeObject);
    }
}


export function changeAction(target, canvas, width) {

    switch (target) {
        case "select":
            canvas.isDrawingMode = false;
            break;
        case "erase":
            canvas.get("backgroundImage")?.set({
                erasable: false
            });

            saveCanvasState(canvas);

            var itemselected = canvas.getActiveObject();
            if (itemselected) {
                itemselected.opacity = 0.4;
            }
            enableEraser(canvas, width);

            break;
        case "undo":
            canvas.freeDrawingBrush = new fabric.EraserBrush(canvas);
            canvas.freeDrawingBrush.width = 10;
            canvas.freeDrawingBrush.inverted = true;
            canvas.isDrawingMode = false;
            break;
        case "draw":
            saveCanvasState(canvas);
            enableDraw(canvas, width);
            break;
        case "spray":
            canvas.freeDrawingBrush = new fabric.SprayBrush(canvas);
            canvas.freeDrawingBrush.width = 35;
            canvas.isDrawingMode = true;
            saveCanvasState(canvas);
            break;
        default:
            break;
    }
}

export function enableEraser(canvas, width) {



    //   canvas.on('mouse:up', function() {
    //     // Save the canvas state when the mouse button is released
    //     saveCanvasState(canvas);
    //   });

    var eraserCursor = "url('data:image/x-icon;base64,AAACAAEAICACAAAAAAAwAQAAFgAAACgAAAAgAAAAQAAAAAEAAQAAAAAAgAAAAAAAAAAAAAAAAgAAAAAAAAAAAAAA66TnAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAC4AAABuAAAA4AAAAdwAAAO4AAAHcAAABuAAAAXAAAADgAAAAAAAAA///////////////////////////////////////////////////////////////////////////////////////////////////////////+D////A////gP///wD///4A///8Af//+AP///AH///wD///8B////A////wf///8='), auto";

    canvas.freeDrawingBrush = new fabric.EraserBrush(canvas);
    canvas.freeDrawingBrush.width = width;
    canvas.isDrawingMode = true;
    canvas.freeDrawingCursor = eraserCursor;
    canvas.setCursor(eraserCursor);

    // ... rest of the code ...
      // Attach path:created event listener to save canvas state
  canvas.on('path:created', function() {
    saveCanvasState(canvas);
  });
}

export function enableDraw(canvas, width, color) {

    color = color || 'itemColor';

    var drawCursor = "url('data:image/x-icon;base64,AAACAAEAICAAAAAAAACoCAAAFgAAACgAAAAgAAAAQAAAAAEACAAAAAAAAAQAAAAAAAAAAAAAAAEAAAAAAAAAAAAAzczOAOLi4gCmpqYAvb29ADAmQwAvJUkA1NTUADEmTAAyJ08A6+vrADQqTwCIiYcAuLi4AM/PzwAsIUcAamKAAC4oQQDm5uYAQzpbAKqqqgDBwcEAb2WJADMrSgDY2NgANSxNAExFWAAkJCQAc2uJAO/v7wBMQ2QAn5i0AMrKygDh4eEApaWlALy8vACTjaYAMCdIAG1nfgAwJUsAMSZOAOrq6gA0LUgAXFRzADUnUQAjGjQAXlV2AMXFxQAoKCgAt7e3AGVdfACloLIALSVDAOXl5QCpqakAMCNPADAlTAAxJFIA19fXADMnUgCbm5sAIyMjAO7u7gA5Mk8AycnJACYdPgAVFRUAPTJYAC0lRACSiqgALis7AFdQaQAwJU0A6enpAEY7YQCtra0AxMTEAIiIiACGf5oA29vbADgtUwB2bowAZFx7ABkZGQDk5OQAMCVFADEiTgAwI1EA1tbWADMoTgAiIiIANClRAO3t7QCwrroAdG6EAE5JXwA6MFQAT0ZoAN/f3wBRSWgAurq6AFlZWQBsZIIALyRMAOjo6ACsrKwANCxJAIV+mQCHh4cA2traADcwTAAmJiYA8fHxALW1tQCLhZwAoZqtAIuAqADMzMwAenSOAHt0jgA+NFgAKx5EAOPj4wBAN1gAp6enAFVNbAAwIU0AMCZKADAoRwAwJE0A1dXVAJmZmQAfGDMA7OzsALCwsADY19sASUBhAId/nQBhW3IA3t7eADwzTQDKy8oALSZCAEI4XAAuI0sA5+fnAG1mgQAwJE4AhoaGANnZ2QAlJSUAdG6HAPDw8ABNQmgAYlx2AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABlPRsbGxsbG2VLFBhPYnqRaCkKXJhwAAAAAAAAAAAAAJY9GxsbGxs9PQMEFUAOgm2LEkkphR0AAAAAAAAAAAAAYhsbGxsbGxsbG4IYT2J6NWhJhT6YcAAAAAAAAAAAAAAAPRsbGxsbGxtvPQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGxsbGxsbGxs9AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGzAbGxtaZQ0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFM9Qi9LZSNUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYEnUUbGRMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABiISBpTSOGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABYkSAUlGQiAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA6AiA2TTE8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHekB8TWSDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB2VVEADDHEaAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA46eo1zVSyMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGHRztISAtuAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAV2fQlISDeOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGp3Y1mBSDiaAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHuXYWcoSDldAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAM5JRmVtIJwgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAX3ReHpNISCgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPx8cSpBISEQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgEUmiA9ICS0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFyRmE2dIfgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVnIQj2d/UAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJU5SQycoKgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAeWuKeEg3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABokrJ0gRAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQWsuYFcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQRYyGUYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIQ0AP//////////gAAB/4AAAf+AAAH/wA///+AP///wD////AP///8B////gP///8B////gP///8B////AP///4B////AP///4B////AP///4B///+Af///wD///+Af///wD///+A////wH///+A////wP///+B////wf///+D////5'), auto";

    canvas.freeDrawingBrush = new fabric.PencilBrush(canvas);
    canvas.freeDrawingBrush.width = width;
    canvas.isDrawingMode = true;
    canvas.freeDrawingCursor = drawCursor;
    canvas.freeDrawingBrush.color = color;
    canvas.setCursor(drawCursor);

    // ... rest of the code ...
      // Attach path:created event listener to save canvas state
  canvas.on('path:created', function() {
    saveCanvasState(canvas);
  });
}


// ==========================================
// PAN FUNCTION
// ==========================================
function panToActiveObject(position, canvas) {
    // https://codepen.io/MarsAndBack/pen/PoZXpWQ
    // Pan the entire canvas so that the active object is centered in the viewport.
    // The object's relative position in the canvas should not change.

    let object = canvas.getActiveObject();
    if (!object) return false;
    let objWidth = object.getScaledWidth();
    let objHeight = object.getScaledHeight();
    let zoom = canvas.getZoom();
    var lpanX = 0;
    var lpanY = 0;

    lpanX =
        (canvas.getWidth() / zoom / 2 - object.aCoords.tl.x - objWidth / 2) *
        zoom;

    if (!position || position === "center-center") {
        lpanY =
            (canvas.getHeight() / zoom / 2 - object.aCoords.tl.y - objHeight / 2) *
            zoom;
    } else if (position === "center-top") {
        lpanY = (-object.aCoords.tl.y + 50) * zoom;
    } else if (position === "center-bottom") {
        lpanY =
            (canvas.getHeight() / zoom - object.aCoords.tl.y - (objHeight + 50)) *
            zoom;
    }

    canvas.setViewportTransform([zoom, 0, 0, zoom, lpanX, lpanY]);

    panX = lpanX;
    panY = lpanY;
}

export function panZoomOut(canvas) {
    saveCanvasState(canvas, canvas.getZoom());
    panX = panY = 0;
    var zoom = canvas.getZoom() / 1.3;
    var actObj = canvas.getActiveObject();
    if (actObj) {
        canvas.setZoom(zoom);
        panToActiveObject("center", canvas);
    } else {
        canvas.setZoom(zoom);
    }
}

export function panZoomIn(canvas) {
    saveCanvasState(canvas, canvas.getZoom());
    panX = panY = 0;
    var zoom = canvas.getZoom() * 1.3;
    var actObj = canvas.getActiveObject();
    if (actObj) {
        canvas.setZoom(zoom);
        panToActiveObject("center", canvas);
    } else {
        canvas.setZoom(zoom);
    }
}

export function goLeft(canvas) {
    var units = 10;
    panX += -units;
    var delta = new fabric.Point(-units, 0);
    canvas.relativePan(delta);
}

export function goRight(canvas) {
    var units = 10;
    panX += units;
    var delta = new fabric.Point(units, 0);
    canvas.relativePan(delta);
}

export function goUp(canvas) {
    var units = 10;
    panY += -units;
    var delta = new fabric.Point(0, -units);
    canvas.relativePan(delta);
}

export function goDown(canvas) {
    var units = 10;
    panY += units;
    var delta = new fabric.Point(0, units);
    canvas.relativePan(delta);
}

export function resetZoom(canvas) {
    var isRecZoom = canvas.getZoom() !== 1 ? true : false;
    if (isRecZoom) saveCanvasState(canvas, canvas.getZoom());
    if (panX || panY) {
        var delta = new fabric.Point(-panX, -panY);
        canvas.relativePan(delta);
        panX = panY = 0;
    }
    canvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
    // canvas.setZoom(1);
    //panToActiveObject('center-center');
    if (isRecZoom) saveCanvasState(canvas, canvas.getZoom());
}

export function downloadpng(url, projectName) {

    //image comming from canvasImages/canvasImagesTreated

    fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
            saveAs(blob, `${projectName}.png`);
        });
}


export function objectflipvertical(canvas) {
    var activeObject = canvas.getActiveObject();
    var grpobjs = canvas.getActiveObjects();
    if (!canvas.getActiveObject()) {

        alert(i18n.t("Please select an item"));
        return;
    }
    if (grpobjs) {
        grpobjs.forEach((object) => {
            if (object.flipY) object.flipY = false;
            else object.flipY = true;
            canvas.renderAll();
        });
    } else {
        if (activeObject.flipY) activeObject.flipY = false;
        else activeObject.flipY = true;
        canvas.renderAll();
    }
    setObjectPerspective(canvas);
}

export function objectfliphorizontal(canvas) {
    var activeObject = canvas.getActiveObject();
    var grpobjs = canvas.getActiveObjects();
    if (!canvas.getActiveObject()) {

        alert(i18n.t("Please select an item"));
        return;
    }
    if (grpobjs) {
        grpobjs.forEach((object) => {
            if (object.flipX) object.flipX = false;
            else object.flipX = true;
            canvas.renderAll();
        });
    } else {
        if (activeObject.flipX) activeObject.flipX = false;
        else activeObject.flipX = true;
        canvas.renderAll();
    }
    setObjectPerspective(canvas);
}

export function cutItem(canvas) {
    if (!canvas) {
        console.error("Canvas instance is missing");
        return;
    }

    // Save the current canvas state
    saveCanvasState(canvas);

    const activeObjects = canvas.getActiveObjects();

    if (!activeObjects || activeObjects.length === 0) {
        alert(i18n.t("Please select one or more items"));
        return;
    }

    // Clone all active objects (optional, depending on your needs)
    activeObjects.forEach((activeObject) => {
        activeObject.clone(function (cloned) {
            // You can use the cloned object if needed
            cloneItem = cloned; // This overwrites cloneItem globally, use carefully
        });
    });

    // Remove all active objects
    activeObjects.forEach((activeObject) => {
        canvas.remove(activeObject);
    });

    // Clear selection and re-render
    canvas.discardActiveObject().renderAll();
}



export function copyItem(canvas) {
    var aObj = canvas.getActiveObject();
    if (!aObj) {
        alert(i18n.t("Please select an item"));
        return
    }
    if (aObj.type === 'activeSelection') {
        alert(i18n.t("cloning multiple items"));
        return;
    }
    else {
        aObj.clone(function (cloned) {
            cloned.itemUrl = aObj.itemUrl;

            if (cloned.type === "activeSelection" && cloned._objects && cloned._objects.length > 1) {
                cloned._objects[1].optionType = aObj._objects[1].optionType;
            }

            cloneItem = cloned;
        });
    }
}

export function pasteItem(canvas) {
    if (!cloneItem)
        alert(i18n.t("Please copy an item first"));
    else {
        cloneItem.clone(function (clonedObj) {
            clonedObj.itemUrl = cloneItem.itemUrl;

            canvas.discardActiveObject();
            clonedObj.set({
                left: clonedObj.left + 10,
                top: clonedObj.top + 10,
                evented: true,
            });

            if (clonedObj.type === "activeSelection") {
                clonedObj.canvas = canvas;

                if (clonedObj._objects && clonedObj._objects.length > 1) {
                    clonedObj._objects[1].optionType = cloneItem._objects[1].optionType;
                }

                clonedObj.forEachObject(function (obj) {
                    canvas.add(obj);
                });
                clonedObj.setCoords();
            } else {
                canvas.add(clonedObj);
            }

            cloneItem.top += 10;
            cloneItem.left += 10;
            canvas.requestRenderAll();
        });
    }
}
// let cloneItem = null;  // If cloneItem is not declared elsewhere, you can declare it here

export function copyAndPasteItem(canvas) {
    // First, perform the copy
    var aObj = canvas.getActiveObject();
    if (!aObj) {
        alert(i18n.t("Please select an item first"));
        return; // exit if no item is selected
    }

    if (aObj.type === 'activeSelection') {
        alert(i18n.t("Cloning multiple items"));
        return;
    }

    else {
        aObj.clone(function (cloned) {
            cloned.itemUrl = aObj.itemUrl;

            if (cloned.type === "activeSelection" && cloned._objects && cloned._objects.length > 1) {
                cloned._objects[1].optionType = aObj._objects[1].optionType;
            }

            cloneItem = cloned;

            // After performing the copy, now perform the paste
            if (!cloneItem) {
                alert(i18n.t("Please copy an item first"));
            } else {
                cloneItem.clone(function (clonedObj) {
                    clonedObj.itemUrl = cloneItem.itemUrl;

                    canvas.discardActiveObject();
                    clonedObj.set({
                        left: clonedObj.left + 10,
                        top: clonedObj.top + 10,
                        evented: true,
                    });

                    if (clonedObj.type === "activeSelection") {
                        clonedObj.canvas = canvas;

                        if (clonedObj._objects && clonedObj._objects.length > 1) {
                            clonedObj._objects[1].optionType = cloneItem._objects[1].optionType;
                        }

                        clonedObj.forEachObject(function (obj) {
                            canvas.add(obj);
                        });
                        clonedObj.setCoords();
                    } else {
                        canvas.add(clonedObj);
                    }

                    cloneItem.top += 10;
                    cloneItem.left += 10;
                    canvas.requestRenderAll();
                });
            }
        });
    }
}



export function groupItems(canvas) {
    if (!canvas.getActiveObject()) {
        return;
    }
    if (canvas.getActiveObject().type !== "activeSelection") {
        return;
    }


    canvas.getActiveObject().toGroup();
    canvas.renderAll();
}

export function unGroupItems(canvas) {
    if (!canvas.getActiveObject()) {

        alert(i18n.t("Please select an item"));
        return;
    }

    if (canvas.getActiveObject().type !== "group") {
        return;
    }
    canvas.getActiveObject().toActiveSelection();
    canvas.renderAll();
}

export const getMediaType = (url) => {
    if (typeof url !== 'string' || !url) {
      console.error('Invalid or undefined URL provided');
      return 'video/mp4'; // Return a default type or handle this case as needed
    }
  
    const extension = url.split('.').pop();
    switch (extension) {
      case 'webm':
        return 'video/webm';
      case 'mp4':
        return 'video/mp4';
      default:
        return 'video/mp4'; // Default fallback to mp4 if extension is unknown
    }
  };
  
  
